module.exports = __webpack_public_path__ + "img/ico-s-delete.3bcb21a6.svg";